import React from "react";
import config from './../config.js';
export default class Archivefiles extends React.Component {

  constructor(props) {
    super(props);
    //console.log(props);
    let user = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }


    const {
      projectid,
      subjectid,
      data_type
    } = props.match.params;
    const pagetitle = '项目管理 ';
    const page_subtitle = data_type.toUpperCase() + ' 其它数据详情';
    this.state = {
      user: user,
      projectid: projectid,
      page_title: pagetitle,
      page_subtitle: page_subtitle,
      subjectid: subjectid,
      data_type: data_type, //MR or PT [modality]
      subject: ''
    }

    document.title = pagetitle + page_subtitle;

    this.goback = this.goback.bind(this);

  }

  componentDidMount() {
    this.onInitialSubject();
  }

  goback() {
    this.props.history.goBack(1);
  }

  onInitialSubject() {
    const me = this;
    let {
      user,
      projectid,
      subjectid,
      data_type
    } = me.state;
    const postdata = {
      userid: user.id,
      projectid: projectid,
      subjectid: subjectid,
      data_type: data_type,
      Authorization: localStorage.token,
      post_type: 'archive_files'
    };
    fetch(config.host + '/project_subject/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 1) {
          const data = json.data;
          me.setState({
            subject: data
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }


  approx(bytevalue) { //计算文件单位和大小
    let filebtout = '';
    for (let units = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], n = 0, Approx = bytevalue / 1024; Approx > 1; Approx /= 1024, n++) {
      filebtout = Approx.toFixed(3) + " " + units[n];
    }
    return filebtout;
  }

  render() {
    const {
      projectid,
      data_type,
      subject
    } = this.state;

    return (
      <div className="row">
        <div className="col-9">
          <nav>
            <ol className="breadcrumb  animated fadeInLeft">
              <li className="breadcrumb-item "><a className="text-dark " onClick={this.goback}><strong><i className="fa fa-chevron-left"></i> 返回  </strong></a>
              </li>
              <li className="breadcrumb-item ">{this.state.page_subtitle}</li>
            </ol>
          </nav>

          <div className="bg-white pb-3 animated fadeIn">
            {
              subject!=='' &&
              <div>
                <div className="border-bottom p-2">
                  <div className="text-right text-muted mb-1"> <small> 共{subject.total_archive}件 </small> </div>
                </div>
                <div className="p-3">
								{
									subject.archive.length && subject.archive.map((file,i)=>{
									const file_size = this.approx(file.file_size);
	                return(
                      <div className="d-flex justify-content-between border-bottom mb-2" key={i} >
                        <span className="d-line-block">
                          <label className="control-label">
                          	
                          文件名：{file.file_name}
													</label>
                        </span>
												<span>{file_size}</span>
                        <span className="cursor d-line-block"> <a href={file.download} target="_blank"><i className="fa fa-download"></i></a> </span>
                      </div>
		                )
		              })
		            }
              	</div>
    					</div>
						}
					</div>
				</div>
        <div className="col-3 pt-3">
          {
            subject!=='' &&
                <div className=" animated fadeInDown">
                <h6 className="align-items-center mb-3">
                  受试者详情
                </h6>
                <ul className="list-group mb-3">

                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>编号</span>
                    <span className="text-muted">{subject.subject_name}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>数据类型</span>
                    <span className="text-muted">{data_type}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>姓名</span>
                    <span className="text-muted">{subject.subject_realname}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>年龄</span>
                    <span className="text-muted">{subject.subject_age}</span>
                  </li>

                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>性别</span>
                    <span className="text-muted">{subject.subject_gender===0 ? '男' : '女'}</span>
                  </li>
									<li className="list-group-item d-flex justify-content-between lh-condensed">
										<span>序列</span>
										<span>
										{
											typeof(subject.series) !== 'undefined' && subject.series.length>0 && subject.series.map((se,si)=>{
												return (<span key={si} className="badge badge-success mx-1">{se.series}</span>)
											})
										}
										</span>
									</li>
                </ul>
                </div>
          }

					{
						subject!=='' && subject.task!=='undefined'  && subject.task!==false && subject.task.map((t,i)=>{
							const filesize = this.approx(t.file_size);
							return (
								<ul className="list-group mb-3 animated fadeInDown" key={i}>

                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>加密包</span>
                    <span className="text-muted">{t.file_name}</span>
                  </li>

	                <li className="list-group-item d-flex justify-content-between lh-condensed">
	                  <span>文件大小</span>
	                  <span className="text-muted">{filesize}</span>
	                </li>

	                <li className="list-group-item d-flex justify-content-between lh-condensed">
	                  <span>处理状态</span>
	                  <span className="text-muted">{t.status==='1' ? '解析完成' : '正在解析'}</span>
	                </li>

	                <li className="list-group-item  lh-condensed">
										<dl>
	                  <dt>诊断说明</dt>
	                  <dd className="text-muted">{t.subject_explain || '无'}</dd>
										</dl>
	                </li>

								</ul>
							)
						})

					}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/apps/console/archive_files.js